import { render, staticRenderFns } from "./InformationNotes.vue?vue&type=template&id=912c3294"
import script from "./InformationNotes.vue?vue&type=script&lang=js"
export * from "./InformationNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports